import ClipboardDialog from './clipboard-dialog/clipboard-dialog.vue'
import Vue from 'vue'

/**
 * 设置系统剪贴板的内容
 * @param {string} data 需要设置的内容
 * @returns {Promise} 设置状态
 */
export function setClipboardData(data) {
    return new Promise((success, fail) => {
        if (!document.queryCommandSupported('copy')) {
            // 不支持
            return false
        }
        console.log(data)
        const result = copyText(data)
        if (result) {
            success(result)
        }
        else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            // iOS 浏览器特殊处理，需要按钮触发复制
            const ComponentConstructor = Vue.extend(ClipboardDialog)
            const instance = new ComponentConstructor({
                el: document.createElement('div'),
                propsData: {
                    content: data
                }
            })
            document.body.appendChild(instance.$el)
            instance.onCopy = (res) => {
                console.log(res)
                res ? success(res) : fail(res)
                instance.$el.remove()
            }
            console.log(instance)

        } else {
            fail(result)
        }
    });
}

export function copyText(text) {
    // 数字没有 .length 不能执行selectText 需要转化成字符串
    const textString = text.toString();
    let input = document.querySelector('#copy-input');
    if (!input) {
        input = document.createElement('input');
        input.id = "copy-input";
        input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.top = "0px";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        input.style.width = "1";
        input.style.heigh = "1";
        document.body.appendChild(input)
    }

    input.value = textString;
    let result = false
    // ios必须先选中文字且不支持 input.select();
    selectText(input, 0, textString.length);
    if (document.execCommand('copy')) {
        result = document.execCommand('copy');
    } else {
        console.log('不兼容');
    }
    input.blur();

    // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
    // 选择文本。createTextRange(setSelectionRange)是input方法
    function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) { //ie
            const range = textbox.createTextRange();
            range.collapse(true);
            range.moveStart('character', startIndex); //起始光标
            range.moveEnd('character', stopIndex - startIndex); //结束光标
            range.select(); //不兼容苹果
        } else { //firefox/chrome
            textbox.setSelectionRange(startIndex, stopIndex);
            textbox.focus();
        }
    }
    return result
}

